import PropTypes from 'prop-types';
import React from 'react';

import Theme from 'styles/theme';
import I18n from 'utils/I18n';

const Details = ({ headline, colorName, localizedSize }) => (
  <div className="Details">
    <div className="Details__headline">{headline}</div>
    <div className="Details__color">{colorName}</div>
    {localizedSize && (
      <div className="Details__size">{`${I18n.localize(
        'cart.upsells.size'
      )}: ${localizedSize}`}</div>
    )}
    <style jsx>
      {`
        .Details {
          overflow: hidden;
        }

        .Details__headline {
          font-weight: ${Theme.get('font-weight-semi-bold')};
          font-size: ${Theme.get('font-size-small-px')};
          line-height: 18px;
        }

        .Details__color,
        .Details__size {
          font-weight: ${Theme.get('font-weight-normal')};
          font-size: ${Theme.get('font-size-small-px')};
          line-height: 18px;
        }
      `}
    </style>
  </div>
);

Details.propTypes = {
  headline: PropTypes.string.isRequired,
  colorName: PropTypes.string.isRequired,
  localizedSize: PropTypes.string.isRequired,
};

export default Details;
